module.exports = __webpack_public_path__ + "img/LogoAPT.424c0859.png";